import Config from '@/config';

// Per-worker comms backend, as reported by graphy's allowlist. Kept as a shared
// type for the badge + worker APIs. There is no global backend swap — the main
// inbox is always PubNub and Supabase is reached via the dedicated ops pages.
export type CommsBackend = 'supabase' | 'pubnub';

export function getSupabaseConfig() {
  return {
    url: Config.SUPABASE_URL ?? '',
    publishableKey: Config.SUPABASE_PUBLISHABLE_KEY ?? '',
  };
}
